export default {"src":"/_next/static/image/public/images/email_update_avatar.2048069fcaadf457343e9060550bd20f.svg","height":126,"width":123};